/*eslint-disable no-undef */
import phina from 'phina.js'

export default ()=>{
/**
 * バフアイコン
*/
phina.define('BuffIcon', {
    superClass: 'phina.display.DisplayElement',
    init: function(param){
      param = (param||{}).$safe(BuffIcon.defaults);
      param.frontIndex=
        BuffIcon.colorMap['w']+BuffIcon.typeMap[param.type];
      param.backIndex=
        BuffIcon.colorMap[param.color]+BuffIcon.typeMap[param.type];
      this.superInit(param);
      phina.display.RectangleShape({
        width:param.width, height:param.height, fill:'black',stroke:'transparent',
      }).addChildTo(this)
        .fromJSON({ alpha:0.5 });
      phina.display.Sprite(param.image,param.frameWidth,param.frameHeight)
        .addChildTo(this)
        .setFrameIndex(param.backIndex)
        .setSize(param.width,param.height)
        .tweener
          .set({ alpha:0.0,scaleX:2.0,scaleY:2.0 })
          .to({ alpha:1.0,scaleX:1.0,scaleY:1.0 },500);
      var popup=phina.display.DisplayElement({
      }).addChildTo(this).setPosition(-param.width/2,param.height/2)
      if(param.popup){
        phina.display.RectangleShape({
          width:100,height:param.height,
          stroke:'transparent',fill:'#000',
        }).fromJSON({alpha:0.5}).addChildTo(popup).setPosition(0,0);
        phina.display.LabelArea({
          width:100,height:param.height,
          text:param.name, fontSize:18, align:'left',
        }).addChildTo(popup).setPosition(0,0);
        popup.tweener
          .set({scaleX:0.0,scaleY:0.0})
          .to({x:(100-param.width)/2,y:param.height,
            scaleX:1.0,scaleY:1.0},200)
          .wait(1600)
          .to({x:-param.width/2,y:param.height/2,
              scaleX:0.0,scaleY:0.0},200)
          .call(function(){ popup.remove(); });  
      }
/*
      var front=phina.display.Sprite(param.image,param.frameWidth,param.frameHeight)
        .addChildTo(this)
        .setFrameIndex(param.frontIndex)
        .fromJSON({blendMode:'hard-light'})
        .setSize(param.width,param.height)
        .tweener
          .set({ alpha:0.0,scaleX:2.0,scaleY:2.0 })
          .to({ alpha:1.0,scaleX:1.0,scaleY:1.0 },500)
          .call(function(){
            front.clear()
              .fadeIn(1000,'easeInCubic')
              .fadeOut(1000,'easeOutCubic')
              .setLoop(true);
          });
*/
    },
    _static:{
      defaults: {
        width:30, height:30, frameWidth:30, frameHeight:30,
        type:'buff', color:'r', image:'noimage',
        name:'', comment:'', popup:true,
      },
      colorMap: { 'a':0,'r':10,'b':20,'y':30,'s':40,'g':50,'w':60,'d':70,'n':80 },
      typeMap: {
        'none':0,
        'buff-magic':1,
        'debuff-magic':2,
        'buff-stance':3,
        'debuff-stance':4,
        'buff-mental':5,
        'debuff-mental':6,
        'buff-physical':7,
        'debuff-physical':8,
        'debuff-ct':9,
    }
    }
});
}